module.exports = __webpack_public_path__ + "static/iphonex-24-fb69d8d2ea02eb0403c4ad94803757d2.png";